import React from "react"
import PropTypes from "prop-types"
import mount from "core/mount"
import { Note } from "@kit/design/note"
import { LinkButton } from "@kit/design/link-button"
import useLocalStorage from "@kit/design/use-localstorage"
import { SignalsLaunchOfferNote } from "app/signals-launch-offer/signals-launch-offer-note"

export const DISMISSED_STORAGE_KEY = "signals-launch-offer-banner:dismissed"

export function SignalsLaunchOfferBanner({
  percentOff,
  targetInterval,
  endsAt
}) {
  const [dismissed, setDismissed] = useLocalStorage(
    DISMISSED_STORAGE_KEY,
    false
  )

  if (dismissed) return null

  return (
    <div className="p-4">
      <SignalsLaunchOfferNote offer={{ percentOff, targetInterval, endsAt }}>
        <Note.Actions>
          <LinkButton variant="secondary" size="small" href="/signals">
            Claim your offer
          </LinkButton>
        </Note.Actions>
        <Note.Dismiss onDismiss={() => setDismissed(true)} />
      </SignalsLaunchOfferNote>
    </div>
  )
}

SignalsLaunchOfferBanner.propTypes = {
  percentOff: PropTypes.number.isRequired,
  targetInterval: PropTypes.oneOf(["year", "month"]).isRequired,
  endsAt: PropTypes.string
}

mount({ "Layout.SignalsLaunchOfferBanner": SignalsLaunchOfferBanner })
